import React from 'react'
import Lightbox from '@saas/react-image-lightbox'
import { isSafari } from '../../utils/commonUtils'

const MediaViewer = ({
    source,
    onClose,
    enableRotate = true,
    hasNext = false,
    hasPrevious = false,
    handleNext = () => undefined,
    handlePrevious = () => undefined,
    mediaName = null,
    toolbarButtons = [],
}: any) => (
    <Lightbox
        mainSrc={source}
        clickOutsideToClose={!isSafari()}
        onCloseRequest={onClose}
        enableRotate={enableRotate}
        onMoveNextRequest={hasNext ? handleNext : undefined}
        onMovePrevRequest={hasPrevious ? handlePrevious : undefined}
        imageTitle={mediaName}
        toolbarButtons={Array.isArray(toolbarButtons) ? toolbarButtons : []}
    />
)

export default MediaViewer
